import { css } from '@/styled-system/css';

export const disclaimer = css({
  fontSize: 'body-xs',
  color: 'text.subtle',
});

export const inlineDetailBody = css({
  paddingInline: 0,
  paddingBlock: 0,
  gap: 'default',
});

export const bedPillRow = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 'tightest',
});

export const unitSelect = css({
  marginTop: 'tighter',
});
